export const TIMEOFF_ACTION = {

  // Get Time Off Requests
  REQUEST_GET_TIMEOFF_REQUESTS: "REQUEST_GET_TIMEOFF_REQUESTS",
  RESPONSE_GET_TIMEOFF_REQUESTS: "RESPONSE_GET_TIMEOFF_REQUESTS",
  ERROR_GET_TIMEOFF_REQUESTS: "ERROR_GET_TIMEOFF_REQUESTS",
  RESET_GET_TIMEOFF_REQUESTS_STATE: "RESET_GET_TIMEOFF_REQUESTS_STATE",

  // Get Time Off by ID
  REQUEST_GET_TIMEOFF_BY_ID: "REQUEST_GET_TIMEOFF_BY_ID",
  RESPONSE_GET_TIMEOFF_BY_ID: "RESPONSE_GET_TIMEOFF_BY_ID",
  ERROR_GET_TIMEOFF_BY_ID: "ERROR_GET_TIMEOFF_BY_ID",
  RESET_GET_TIMEOFF_BY_ID_STATE: "RESET_GET_TIMEOFF_BY_ID_STATE",

  // Update Time Off
  REQUEST_UPDATE_TIMEOFF: "REQUEST_UPDATE_TIMEOFF",
  RESPONSE_UPDATE_TIMEOFF: "RESPONSE_UPDATE_TIMEOFF",
  ERROR_UPDATE_TIMEOFF: "ERROR_UPDATE_TIMEOFF",
  RESET_UPDATE_TIMEOFF_STATE: "RESET_UPDATE_TIMEOFF_STATE",

  // Cancel Time Off
  REQUEST_CANCEL_TIMEOFF: "REQUEST_CANCEL_TIMEOFF",
  RESPONSE_CANCEL_TIMEOFF: "RESPONSE_CANCEL_TIMEOFF",
  ERROR_CANCEL_TIMEOFF: "ERROR_CANCEL_TIMEOFF",
  RESET_CANCEL_TIMEOFF_STATE: "RESET_CANCEL_TIMEOFF_STATE",

  // Request Time Off
  REQUEST_REQUEST_TIMEOFF: "REQUEST_REQUEST_TIMEOFF",
  RESPONSE_REQUEST_TIMEOFF: "RESPONSE_REQUEST_TIMEOFF",
  ERROR_REQUEST_TIMEOFF: "ERROR_REQUEST_TIMEOFF",
  RESET_REQUEST_TIMEOFF_STATE: "RESET_REQUEST_TIMEOFF_STATE",

  // Get All Time Off Requests Using User ID
  REQUEST_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID: "REQUEST_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID",
  RESPONSE_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID: "RESPONSE_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID",
  ERROR_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID: "ERROR_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID",
  RESET_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID_STATE: "RESET_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID_STATE",

};


export const requestGetTimeOffRequestsAction = (payload) => ({
  type: TIMEOFF_ACTION.REQUEST_GET_TIMEOFF_REQUESTS,
  data: payload
});

export const responseGetTimeOffRequestsAction = (res) => ({
  type: TIMEOFF_ACTION.RESPONSE_GET_TIMEOFF_REQUESTS,
  data: res
});

export const errorGetTimeOffRequestsAction = (payload) => ({
  type: TIMEOFF_ACTION.ERROR_GET_TIMEOFF_REQUESTS,
  data: payload
}); 


export const resetGetTimeOffRequestsStateAction = () => ({
  type: TIMEOFF_ACTION.RESET_GET_TIMEOFF_REQUESTS_STATE,
  data: undefined
});


// Get Time Off By ID
export const requestGetTimeOffByIdAction = (payload) => ({
  type: TIMEOFF_ACTION.REQUEST_GET_TIMEOFF_BY_ID,
  data: payload
});

export const responseGetTimeOffByIdAction = (payload) => ({
  type: TIMEOFF_ACTION.RESPONSE_GET_TIMEOFF_BY_ID,
  data: payload
});

export const errorGetTimeOffByIdAction = (payload) => ({  
  type: TIMEOFF_ACTION.ERROR_GET_TIMEOFF_BY_ID,
  data: payload
});

export const resetGetTimeOffByIdStateAction = () => ({
  type: TIMEOFF_ACTION.RESET_GET_TIMEOFF_BY_ID_STATE,
  data: undefined
});

// Update Time Off
export const requestUpdateTimeOffAction = (payload) => ({
  type: TIMEOFF_ACTION.REQUEST_UPDATE_TIMEOFF,
  data: payload
});

export const responseUpdateTimeOffAction = (payload) => ({
  type: TIMEOFF_ACTION.RESPONSE_UPDATE_TIMEOFF,
  data: payload
});

export const errorUpdateTimeOffAction = (payload) => ({ 
  type: TIMEOFF_ACTION.ERROR_UPDATE_TIMEOFF,
  data: payload
});

export const resetUpdateTimeOffStateAction = () => ({
  type: TIMEOFF_ACTION.RESET_UPDATE_TIMEOFF_STATE,
  data: undefined
});

export const requestCancelTimeOffAction = (payload) => ({
  type: TIMEOFF_ACTION.REQUEST_CANCEL_TIMEOFF,
  data: payload
});

export const responseCancelTimeOffAction = (payload) => ({
  type: TIMEOFF_ACTION.RESPONSE_CANCEL_TIMEOFF,
  data: payload
});

export const errorCancelTimeOffAction = (payload) => ({
  type: TIMEOFF_ACTION.ERROR_CANCEL_TIMEOFF,
  data: payload
});

export const resetCancelTimeOffStateAction = () => ({
  type: TIMEOFF_ACTION.RESET_CANCEL_TIMEOFF_STATE,
  data: undefined
});

export const requestRequestTimeOffAction = (payload) => ({
  type: TIMEOFF_ACTION.REQUEST_REQUEST_TIMEOFF,
  data: payload
});

export const responseRequestTimeOffAction = (payload) => ({
  type: TIMEOFF_ACTION.RESPONSE_REQUEST_TIMEOFF,
  data: payload
});

export const errorRequestTimeOffAction = (payload) => ({
  type: TIMEOFF_ACTION.ERROR_REQUEST_TIMEOFF,
  data: payload
});

export const resetRequestTimeOffStateAction = () => ({
  type: TIMEOFF_ACTION.RESET_REQUEST_TIMEOFF_STATE,
  data: undefined
});

export const requestGetAllTimeOffRequestsUsingUserIdAction = () => ({
  type: TIMEOFF_ACTION.REQUEST_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID,
  data: undefined
});

export const responseGetAllTimeOffRequestsUsingUserIdAction = (payload) => ({
  type: TIMEOFF_ACTION.RESPONSE_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID,
  data: payload
});

export const errorGetAllTimeOffRequestsUsingUserIdAction = (payload) => ({
  type: TIMEOFF_ACTION.ERROR_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID,
  data: payload
});

export const resetGetAllTimeOffRequestsUsingUserIdStateAction = () => ({
  type: TIMEOFF_ACTION.RESET_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID_STATE,
  data: undefined
});
